
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcTabItem as ObcTabItemElement} from '@oicl/openbridge-webcomponents/dist/components/tab-item/tab-item.js';
 
 
 

 
 export const ObcTabItem = createComponent({
   react: React,
   tagName: 'obc-tab-item',
   elementClass: ObcTabItemElement,
   events: {
     
     onTabClick: 'tab-click' as EventName<CustomEvent<{title: string}>>,
     onTabClose: 'tab-close' as EventName<CustomEvent<{title: string}>>,
   }
  });
 
 